import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function PainSection() {
  return <section className="bg-[#1C1C1C] py-12 md:py-18 px-5 md:px-12" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        {/* Section Label */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-95">
          <div className="h-px w-16 bg-[#C9A96E]/50 mx-auto mb-4" data-id="element-96" />
          <span className="text-[#C9A96E]/70 uppercase tracking-[0.2em] text-xs font-medium" data-id="element-97">
            La Realidad
          </span>
        </motion.div>

        {/* Intro Text */}
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-base md:text-lg text-white/80 text-center leading-relaxed mb-8" data-id="element-98">
          La mayoría de los cursos de costura te enseñan a hacer manteles o ropa
          sencilla.{' '}
          <span className="text-white font-medium" data-id="element-99">
            Pero nadie te dice el secreto para que un salón se vea costoso.
          </span>
        </motion.p>

        {/* Pain Points */}
        <div className="space-y-4" data-id="element-100">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex items-start gap-4 bg-white/5 border border-white/10 rounded-lg p-4 md:p-5" data-id="element-101">
            <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-0.5" data-id="element-102" />
            <p className="text-base md:text-lg text-white/90 leading-relaxed" data-id="element-103">
              ¿Cansada de que tus cortinas se vean{' '}
              <span className="text-white font-medium" data-id="element-104">
                "pobres" y sin volumen
              </span>
              ?
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex items-start gap-4 bg-white/5 border border-white/10 rounded-lg p-4 md:p-5" data-id="element-105">
            <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-0.5" data-id="element-106" />
            <p className="text-base md:text-lg text-white/90 leading-relaxed" data-id="element-107">
              ¿Tus cojines{' '}
              <span className="text-white font-medium" data-id="element-108">
                se deforman y se ven aplastados
              </span>{' '}
              a los dos días?
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex items-start gap-4 bg-white/5 border border-white/10 rounded-lg p-4 md:p-5" data-id="element-109">
            <XCircleIcon className="w-6 h-6 text-red-400/80 flex-shrink-0 mt-0.5" data-id="element-110" />
            <p className="text-base md:text-lg text-white/90 leading-relaxed" data-id="element-111">
              ¿Gastas dinero en telas caras y el resultado final sigue
              pareciendo{' '}
              <span className="text-white font-medium" data-id="element-112">"hecho en casa"</span>?
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}